// import { AnnouncementComponent } from "./announcement/announcement.component";
import { FeedBackDeclaration } from './feedback/feedback.declaration';
import { AnnouncementDeclaration } from './announcement/announcement.declaration';
import { SupportDeskComponent } from './support-desk.component';
import { ComplaintsDeclaration } from './complaints/complaints.declaration';
import { TicketsDeclaration } from './tickets/tickets.declaration';

export const SupportDeclarations = [
    AnnouncementDeclaration,
    ComplaintsDeclaration,
    FeedBackDeclaration,
    TicketsDeclaration,
    

    SupportDeskComponent

];
